import React from 'react';
export default {
  'cart': {
    'change-currency': 'Alterar moeda',
    'and-then': 'E depois',
    'plus-tax': ' + impostos',
    'for': 'Para',
    'edit': {
      'label': 'Editar',
      'submit': 'Aplicar'
    },
    'empty': 'Você ainda não adicionou nada no seu pedido.',
    'free': 'grátis',
    'promo-code': {
      'add': 'Adicione um cartão-presente ou código promocional',
      'error': {
        'invalid-for-subscription': 'O código do cupom não é válido para este pedido.'
      },
      'label': 'Cartão-presente ou código promocional',
      'submit': 'Aplicar'
    },
    'subtotal-line': {
      'tax-label': 'Imposto estimado',
      'subtotal': 'Sub-total',
      'tax': 'imposto',
      'gift-card': 'cartão presente'
    },
    'starting-price': 'Preço inicial',
    'title': 'Resumo do pedido',
    'setup-fee': 'taxa de configuração',
    'free-trial': 'teste grátis',
    'total-line': {
      'label': 'Total'
    },
    'order-total-line': {
      'label': 'Total da Encomenda'
    }
  },
  'address': {
    'country': 'País',
    'address2': 'Apartamento, suíte etc.',
    'tax-identifier': 'Identificador fiscal',
    'tax-identifier-type': 'Tipo de identificador fiscal',
    'first-name': 'Primeiro nome',
    'last-name': 'Último nome',
    'company-name': 'Nome da Empresa',
    'address1': 'Endereço:',
    'city': 'Cidade',
    'state': 'Província',
    'postal-code': 'Código Postal',
    'phone-number': 'Número de telefone',
    'vat-number': 'Número IVA/ID Fiscal'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Dados do cartão',
      'expiry': 'MM/AA',
      'name': 'Cartão De Crédito',
      'number': 'Número do Cartão de Crédito',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Conta Bancária',
      'routing-number': 'Número Routing',
      'account-number': 'Número De Conta',
      'account-number-confirmation': 'Confirme Número de Conta',
      'account-type': {
        'label': 'Tipo De Conta',
        'checking': 'Conta Corrente',
        'savings': 'Caderneta de poupança'
      },
      'name-on-account': 'Nome em Conta'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Código Sort'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'Código BSB'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Endereço de cobrança',
  'billing-address-same-as-shipping': 'Igual ao endereço de entrega',
  'submit': 'Pagar agora',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} selecionado</>,
  'express-checkout': 'Compra Expressa',
  'change-payment-method': 'Mudar modo de pagamento',
  'day': 'dia',
  'days': 'dias',
  'week': 'semana',
  'weeks': 'semanas',
  'month': 'mês',
  'months': 'meses',
  'year': 'ano',
  'years': 'anos',
  'confirmation': {
    'title': 'Obrigado pelo seu pedido',
    'order-num': ({ number }: { number: number }) => <>Pedido #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Concluído em {date}</>,
    'email-notice': 'Você receberá um e-mail de confirmação do seu pedido.',
    'payment': 'Pagamento',
    'return-to': ({ name }: { name: string }) => <>Devolver a {name}</>,
    'credit-applied': 'Aplicada Crédito'
  },
  'back': 'Voltar',
  'contact-info': 'Informação de Contacto',
  'email-address': 'o email',
  'payment-info': 'Informação de Faturação',
  'shipping-address': 'Endereço de entrega',
  'legal': {
    'accept': 'Aceito o',
    'privacy-policy': 'Política de Privacidade',
    'terms-of-service': 'Termos de Serviço'
  },
  'recurring': {
    'consent': `Eu concordo em pagar as taxas acima, exibidas com uma frequência de cobrança, de forma recorrente,
                a menos que a assinatura seja cancelada antes do final do período de cobrança atual.`,
    'cancel': 'Para cancelar sua assinatura, acesse sua página de Gerenciamento de Conta.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'dia' : 'dias',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'semana' : 'semanas',
    'months': ({ count }: { count: number }) => count === 1 ? 'mês' : 'meses',
    'years': ({ count }: { count: number }) => count === 1 ? 'ano' : 'anos'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>Você será cobrado {amount}/unidade por {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>Você será cobrado {amount} por {units} {unitsLabel} de {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>A partir de {startDate}, você será cobrado {amount}/{intervalLengthLabel}{taxable ? ' + impostos' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>A partir de {startDate}, você será cobrado {amount}/{intervalLengthLabel}{taxable ? ' + impostos' : ''}, junto com uma taxa única de {setupFee}</>,
      'cancellation.reminder': 'Você receberá um lembrete por e-mail {days} dias antes do início da cobrança.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Seu teste gratuito de {trialLength} {trialInterval} começa hoje.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Para evitar ser cobrado, você deve cancelar antes de {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Você receberá um lembrete por e-mail {days} dias antes do início da cobrança.</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Sua assinatura terminará em {billingEndsAt} e não será renovada automaticamente.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Após {afterChargeTime}, você será cobrado {newChargeAmount} + impostos</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Sua assinatura será renovada automaticamente a cada {totalCyclesLengthLabel} e continuará até você cancelar.</>,
      'title': 'Detalhes da Assinatura',
    },
    'agreement.button': 'Aceitar e Continuar',
    'agreement.text': 'Ao clicar em "Aceitar e Continuar", você confirma que compreende e aceita estes termos de assinatura. Nenhuma cobrança será aplicada até você finalizar a compra.',
    'changeOrCancel': 'Para alterar ou cancelar sua assinatura ',
    'access-account': 'acesse sua conta',
    'contact-support': 'entre em contato com o suporte',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ',',
      'twoWordsConnector': 'e',
      'lastWordConnector': ', e'
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Faturação da assinatura impulsionada por {recurly}</>,
  'errors': {},
  'subscribe': 'Subscrever'
};
